require('d3');
require('nvd3');
require('nvd3/build/nv.d3.css');
require('angular-nvd3');
var clipboardModule = require('angular-clipboard');
var angular = require('angular');

var app = angular.module('amt-admin.charts', ['nvd3', clipboardModule.name]);

app.service('charts_api', ['jsonrpc', function(jsonrpc){
    var service = jsonrpc.newService('charts');
    this.get_options = service.createMethod('get_options');
    this.get_data = service.createMethod('get_data');
    this.get = service.createMethod('get');
}]);

require('./resources/component').default(app);

export default app.name;
